import template from './creditQuoteDetailsModal.html';
import controller from './generateCqpOptionsCtrl';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    loanAppId: '<',
    loanAdviserId: '<',
    loanDetails: '<',
    cpaCqpSet: '<',
    calculatorFundsSummary: '<',
    isAssetFinance: '<',
    isAppendedOnly: '<',
    onNext: '&',
  },
};
